/**
 * @param {*} eid element id to add class
 * @param {*} classname classname to add
 */
export const addClassForElement = function (eid, classname) {
  const element = document.getElementById(eid);
  const classList = element.className.split(' ');
  let found = false;
  for (const c of classList) {
    if (c === 'error') {
      found = true;
    }
  }
  if (!found) {
    element.className += ` ${classname}`;
  }
};

export const removeClassFromElement = function (eid, classname) {
  const element = document.getElementById(eid);
  let classList = element.className.split(' ');
  classList = classList.filter(c => c !== classname);
  element.className = classList.join(' ');
};

export const onInputPhoneNumber = function () {
  hideErrorHintPhoneNumber();
};

export const checkPhoneNumber = function (inputText) {
  return /^\d+$/.test(inputText);
};

export const passwordSpecificationHintsWords = '长度8-16位，必须包含大小写字母和数字';

export const checkPasswordFormat = function (password) {
  if (typeof password !== 'string') {
    return [false, 'NOT a string'];
  }

  // https://stackoverflow.com/questions/19605150/regex-for-password-must-contain-at-least-eight-characters-at-least-one-number-a
  if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,16}$/.test(password)) {
    return [false, passwordSpecificationHintsWords];
  }

  if (/\s/.test(password)) {
    return [false, '密码不能包含空格'];
  }

  if (/.*[\u4e00-\u9fa5]+.*/.test(password)) {
    return [false, '密码不能包含中文字符'];
  }

  // https://stackoverflow.com/questions/8359566/regex-to-match-symbols
  // eslint-disable-next-line no-useless-escape
  if (/^[a-zA-Z\d -/:-@{-~\[-`]+$/.test(password)) {
    return [true, 'ok'];
  }
  return [false, '密码不能包含非法字符'];
};

export const showErrorHintPhoneNumber = function (txt) {
  addClassForElement('phone-num', 'error');
  document.getElementById('phone-num-hints').innerText = txt || '请输入正确的手机号码';
  document.getElementById('phone-num-hints').style.display = '';
};

export const hideErrorHintPhoneNumber = function () {
  removeClassFromElement('phone-num', 'error');
  document.getElementById('phone-num-hints').style.display = 'none';
};

export const onInputCodeNumber = function () {
  hideErrorHintMsgCode();
};

export const showErrorHintMsgCode = function () {
  addClassForElement('code-num', 'error');
  // document.getElementById('code-num-hints').innerText = '验证码错误';
  document.getElementById('code-num-hints').style.display = '';
};

export const hideErrorHintMsgCode = function () {
  removeClassFromElement('code-num', 'error');
  document.getElementById('code-num-hints').style.display = 'none';
};
